declare var window: any;

import {
  createIconSVG,
  getIconClass,
  getTitle,
} from "../../utils/flashMessageHelpers";

const FlashMessages = {
  mounted(this: any) {
    window.addEventListener("flash", ({ detail: detail }: any) => {
      if (!detail.type || !detail.message) return;

      const flash = document.createElement("div");
      flash.setAttribute(
        "class",
        `alert alert-${detail.type} flex items-center w-full md:w-138 py-4 px-6 mb-5 justify-left`,
      );

      const iconContainer = document.createElement("div");
      iconContainer.setAttribute("class", `${getIconClass(detail.type)} mr-4`);
      const icon = createIconSVG(detail.type);
      iconContainer.appendChild(icon);

      const flashBody = document.createElement("div");
      flashBody.setAttribute(
        "class",
        "flex flex-wrap leading-6 text-base -mx-1 md:-108",
      );

      const title = document.createElement("div");
      title.setAttribute("class", "font-bold px-1");
      title.textContent = detail.title || getTitle(detail.type);

      const message = document.createElement("div");
      message.textContent = detail.message;
      message.setAttribute("class", "font-normal px-1");

      const closeBtn = document.createElement("div");
      closeBtn.setAttribute("class", "cursor-pointer text-base ml-auto");
      closeBtn.onclick = () => {
        this.el.removeChild(flash);
      };
      closeBtn.innerHTML = "&times;";

      flash.appendChild(iconContainer);
      flashBody.appendChild(title);
      flashBody.appendChild(message);
      flash.appendChild(flashBody);
      flash.appendChild(closeBtn);
      this.el.appendChild(flash);

      if (this.el.children.length > 5) {
        this.el.removeChild(this.el.firstChild);
      }

      setTimeout(() => {
        if (this.el.contains(flash)) {
          this.el.removeChild(flash);
        }
      }, 4000);
    });
  },
};

export default FlashMessages;
